import printCalendar from "../../../media/printCalendar.png";
import "../../../styles/Containers.css";
import "../../../styles/Colors.css";

function OnBoarding(props) {
  const { title, desc, linkTo, bclass } = props;
  return (
    <div className="gap14 marginUpDown20 marginSide14 centerd">
      {/* <div className="gap14"> */}
      <p className="heading-1 white">{title}</p>
      <p className="heading-2 grey-5 rightAlign">{desc}</p>
      {/* </div> */}
      <img src={printCalendar} alt="printCalendar" />
      <a href={linkTo} className={bclass}>
        بزن بریم
      </a>
    </div>
  );
}
export default OnBoarding;